import { useTranslation } from 'react-i18next'

import { AcknowledgeModal, Modal } from '@percent/lemonade'

export type ArchiveGivingActionFailureModalProps = Readonly<{
  isOpen: boolean
  handleClose: () => void
}>

export function ArchiveGivingActionFailureModal({ isOpen, handleClose }: ArchiveGivingActionFailureModalProps) {
  const { t } = useTranslation()

  return (
    <Modal open={isOpen} onClose={handleClose} aria-labelledby="archive-giving-action-failure">
      <AcknowledgeModal
        result="negative"
        title={t('dialog.givingActions.archive.errorTitle')}
        description={t('dialog.givingActions.archive.errorDescription')}
        buttonText={t('button.close')}
        handleClose={handleClose}
        buttonTestId="archive-giving-action-failure-modal-btn"
      />
    </Modal>
  )
}
